<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1" />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 position-relative"
      >
        <b-navbar-nav class="nav align-items-center ml-auto language-bar">
          <locale />

        </b-navbar-nav>
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('WELCOME_DEBTIA_TEXT') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('DEBTIA_LOGIN_SIGNIN_TEXT') }}
          </b-card-text>

          <b-alert
            :show="error.length > 0"
            variant="danger"
          >
            <div class="alert-body font-small-2">
              <p>
                <small
                  v-for="(item, index) in error"
                  :key="item"
                  class="mr-50"
                ><span class="font-weight-bold">{{ error[index] }}</span></small>
              </p>
            </div>
          </b-alert>

          <!-- form -->
          <validation-observer ref="loginForm">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                :label="$t('DEBTIA_USERNAME')"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    placeholder="username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">{{ $t('DEBTIA_PASSWORD') }}</label>
                  <b-link
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    v-b-modal.forgot-password-link
                  >
                    <small>{{ $t('DEBTIA_FORGOT_PASSWORD') }}</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
              >
                {{ $t('DEBTIA_SIGNIN') }}
              </b-button>
            </b-form>
          </validation-observer>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
    <b-modal
      id="forgot-password-link"
      ref="forgot-password-link-ref"
      :title="$t('DEBTIA_FORGOT_PASSWORD')"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <b-overlay
        id="overlay-background"
        :show="forgetpasswordloader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          class="forgot-password-model"
        >
          <b-card-text>
            <h5>{{ $t('DEBTIA_ENTER_USERNAME') }}</h5>
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label-for="title"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Username"
                        rules="required"
                      >
                        <b-form-input
                          v-model="forgotPasswordUsername"
                          :state="errors.length > 0 ? false:null"
                          :placeholder="$t('DEBTIA_USERNAME')"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-button
                      variant="primary"
                      type="submit"
                      class="addProcessBtn"
                      @click.prevent="validationForm"
                    >
                      {{ $t('DEBTIA_SUBMIT') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-card-text>
        </b-card>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, BNavbarNav, BOverlay,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import axios from '@axios'
import i18n from '@/libs/i18n'
// import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    locale,
    BNavbarNav,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      error: [],
      forgetpasswordloader: false,
      forgotPasswordUsername: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    if (localStorage.getItem('accessToken')) {
      this.$router.replace('/')
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.forgetpasswordloader = true
          const url = '/generate-forgot-password-link'
          axios.post(url, {
            username: this.forgotPasswordUsername,
          }).then(response => {
            if (response.status === 200) {
              this.forgetpasswordloader = false
              this.forgotPasswordUsername = ''
              this.$refs['forgot-password-link-ref'].hide()
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: i18n.t('DEBTIA_RESET_PASSWORD_MESSAGE'),
                },
              })
              // this.$router.push(`/process/view/${response.data.data.id}`)
            }
          }).catch(error => {
            const noinputmsg = error.response.data.message ? error.response.data.message : error.message
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Request Failed',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: noinputmsg,
              },
            })
            this.forgetpasswordloader = false
          })
        }
      })
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            username: this.username,
            password: this.password,
          })
            .then(response => {
              const userData = response.data
              useJwt.setToken(userData.token)
              localStorage.setItem(jwtDefaultConfig.storageUserData, JSON.stringify(userData))
              this.$ability.update(userData.ability)
              this.fetchTranslations()
              axios.get('/user-settings/get-all')
                .then(debtorresponse => {
                  if (debtorresponse.status) {
                    const debtorsOwnedBy = debtorresponse.data.data.filter(element => element.key === 'debtors_own_by')
                    if (debtorresponse.data.data) localStorage.setItem('debtorsBelongTo', debtorsOwnedBy[0].value)
                    const defaultCurrency = debtorresponse.data.data.filter(element => element.key === 'default_currency')
                    if (debtorresponse.data.data && defaultCurrency.length > 0) {
                      localStorage.setItem('defaultCurrency', defaultCurrency[0].value)
                    } else {
                      localStorage.setItem('defaultCurrency', 'DKK')
                    }
                    const bcapisettings = debtorresponse.data.data.filter(element => element.key === 'bc_base_url')
                    if (bcapisettings.length > 0) { localStorage.setItem('bcSettings', 'true') } else localStorage.setItem('bcSettings', 'false')
                    this.$router.replace('/')
                      .then(() => {
                        this.$toast({
                          component: ToastificationContent,
                          position: 'top-right',
                          props: {
                            title: `Welcome ${userData.data.name || userData.data.username}`,
                            icon: 'CoffeeIcon',
                            variant: 'success',
                            text: 'You have successfully logged in. Now you can start to explore!',
                          },
                        })
                      })
                  }
                })
            })
            .catch(error => {
              this.error = error.response.data.message
              this.$refs.loginForm.setErrors(error.response.data.message)
            })
        }
      })
    },
    async fetchTranslations() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const userId = userData?.data?.id
      if (!userId) return
      const response = await axios.get(`translations/get-user-translations/${userId}`)
      // const response1 = await axios.get('/settings/get-countries-dropdown')

      // for (const [lang1, trans1] of Object.entries(response1.data.data)) {
      //   if (lang1 === 'en') {
      //     response.data.data.en.COUNTRIES_DROP_DOWN = trans1
      //   }
      //   if (lang1 === 'da') {
      //     response.data.data.da.COUNTRIES_DROP_DOWN = trans1
      //   }
      // }
      for (const [lang, trans] of Object.entries(response.data.data)) {
        i18n.setLocaleMessage(lang, trans)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.language-bar {
  position: absolute;
    right: 4rem;
    top: 1rem;
    z-index: 1;
}

.addProcessBtn {
    width: 100%;
  }

  .forgot-password-model {
    padding: 40px 150px 100px 150px;
  }
</style>
